export default __webpack_public_path__ + "static/media/Logo_210430.ac9cbf50.jpg";